<template>
  <div class="common-tag-list">
    <span
      v-for="(tag, index) in badgeList"
      :key="index"
      :class="className(tag, index)"
    >
      {{ label(tag, index) }}
    </span>
  </div>
</template>
<script setup>
  import { defineProps } from 'vue'
  const props = defineProps({
    badgeList: {
      type: Array,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
  })

  const className = (tag, index) => {
    if (props.type === 'brand') {
      if (index > 0 || tag === '') return ''
      const wavveList = ['original', 'exclusive', 'firstrun']
      return ['brand', wavveList.includes(tag) ? 'wavve' : tag.toLowerCase()]
    }

    if (props.type === 'bottom') {
      return tag ? `badge artwork ${tag}` : ''
    }
  }

  const label = (tag, index) => {
    if (props.type === 'brand') {
      return index === 0 ? tag : ''
    }

    if (props.type === 'bottom') {
      const labels = {
        new_movie: '신작 업데이트',
        new_vod: '신규 시리즈',
      }
      return labels[tag] || ''
    }
  }
</script>

<style scoped lang="scss"></style>
